<template>
<section id="Devices">
    <h6 class="font-weight-semibold">{{$t('Logged in')}}</h6>
    <div v-if="!onload">
        <div v-if="loggedDevices.length" class="list-devices">
            <div v-for="device in loggedDevices" :key="device.id" class="d-flex align-items-lg-center align-items-start border-bottom px-xl-4 py-2">
                <div class="text-teal mr-3">
                    <i class="far fa-desktop fa-2x p-lg-3 pr-2 py-2" style="color: #b1c5cd;"></i>
                </div>
                <div class="align-items-center d-lg-flex flex-1 justify-content-between">
                    <div class="media-body">
                        <h6 class="media-title font-weight-semibold"><a href="#" class=""><u>{{$t(device.name)}}</u></a></h6>
                        <div>{{ $t(device.updated_at) }}{{ (device.location) ? ', '+device.location : '' }}</div>
                    </div>
                    <button type="button" class="btn btn-outline-normal mt-1 mt-lg-0 mx-lg-3 mx-xl-4" @click="logout(device)">{{$t("Logout")}}</button>
                </div>

            </div>
        </div>
    </div>
    <div v-else>
        <div class="content">
            <placeholder-content isLoad="true" />
        </div>
    </div>
</section>
</template>

<script>
import * as echarts from 'echarts';
import CentralApi from '@/services/endpoint/central.service'
import PlaceholderContent from '@/plugins/PlaceholderContent.vue'

export default {
    components: {
        PlaceholderContent
    },
    data() {
        return {
            onload: true,
            loggedDevices: [],
        };
    },
    mounted() {
        this.getTokens();
    },
    created() {},
    methods: {
        async getTokens() {
            let data = await CentralApi.Auth.getTokens()
            this.loggedDevices = data.data.data
            this.$parent.loggedDevices = this.loggedDevices.length;
            this.onload = false;
        },
        logout(device) {
            this.$swal.fire({
                title: this.$t('Logout from the device') + ' ?',
                icon: 'warning',
                iconColor: '#FF7043',
                html: this.$t("You will have to login again on") + ' ' + device.name,
                showCancelButton: true,
                confirmButtonText: this.$t('Confirm'),
                confirmButtonColor: "#1F88E5",
                cancelButtonText: this.$t('Cancel'),
                buttonsStyling: false,
                customClass: {
                    confirmButton: 'btn btn-primary mr-2',
                    cancelButton: 'btn btn-outline-normal'
                },
                focusConfirm: false
            }).then((result) => {
                if (result.isConfirmed) {

                    let params = {
                        token: device.id,
                    };

                    var self = this;
                    CentralApi.Auth.logoutOtherDevices(params).then(function (res) {
                        self.onload = true;
                        self.getTokens();
                    }).catch((error) => {
                        console.log(error, 'catch');
                    });

                }
            })
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/central/account/security/Devices.vue